const pickFirstNonEmpty = (...candidates) => {
  for (const candidate of candidates) {
    if (candidate == null) continue;
    const trimmed = String(candidate).trim();
    if (trimmed) return trimmed;
  }
  return null;
};

/**
 * Resolve portal notification id from inbox row, FCM data, or SW click payload.
 * Skips empty strings so a blank `id` does not block `notificationId`.
 */
export const pickNotificationId = (source = {}) => {
  const nested = source.data ?? {};

  return pickFirstNonEmpty(
    source.id,
    source._id,
    source.notificationId,
    source.notification_id,
    nested.id,
    nested._id,
    nested.notificationId,
    nested.notification_id,
  );
};
